import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=e34a5d30&"
import script from "./EmptyLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=e34a5d30&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e34a5d30')) {
      api.createRecord('e34a5d30', component.options)
    } else {
      api.reload('e34a5d30', component.options)
    }
    module.hot.accept("./EmptyLayout.vue?vue&type=template&id=e34a5d30&", function () {
      api.rerender('e34a5d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/EmptyLayout.vue"
export default component.exports